﻿import jquery from 'jquery';


class AggregatorRepository {
    
    constructor(aggRepositoryDTO){

        this._aggRepositoryDTO = aggRepositoryDTO;
        this._timeoutAjax = 10000;
    }


    getItems(){
        
        return new Promise((resolve, reject) => {

            const dataAgg = `p=${this._aggRepositoryDTO.parameterP}&pmax=${this._aggRepositoryDTO.pvpMax}&m2=${this._aggRepositoryDTO.supMin}&hab=${this._aggRepositoryDTO.numHab}&tip_op_origen=${this._aggRepositoryDTO.tipOp}`;

            const request = jquery.ajax({
                url: this._aggRepositoryDTO.urlAjaxAgregador,
                type: 'POST',
                data: dataAgg,
                dataType: 'json',
                timeout: this._timeoutAjax});

            request.done((data) => { return resolve(data); });
            request.error((err) => { return reject(err); });
        
        });
        
    }

}

export default AggregatorRepository;
